import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import type { CountryEntity } from '@shared/api';
import { Input } from '@shared/widgets';

interface IBusinessProps {
  name: string;
  countries: CountryEntity[];
  economicActivities: string[];
}

export const Business = (props: IBusinessProps) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid item xs={6}>
        <Controller
          name={`${props.name}.employer`}
          control={control}
          rules={{ required: 'Name is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Name' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name={`${props.name}.country`}
          control={control}
          rules={{ required: 'Location is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControl margin='normal' fullWidth error={!!error}>
                <InputLabel>Location *</InputLabel>
                <Select {...field} variant='standard' fullWidth>
                  {props.countries.map((country) => (
                    <MenuItem key={country.name} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            </>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={`${props.name}.economicActivity`}
          control={control}
          rules={{ required: 'Economic activity is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControl margin='normal' fullWidth error={!!error}>
                <InputLabel>Economic activity *</InputLabel>
                <Select {...field} variant='standard' fullWidth>
                  {props.economicActivities.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            </>
          )}
        />
      </Grid>
    </>
  );
};
